import React, { useState, useRef, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '../data/Contact.css';  
import { ContactInfo } from './ContactInfo';
import { MdMarkEmailRead } from "react-icons/md";
import axios from 'axios';
import { MdError } from "react-icons/md";
import { BsSendFill } from "react-icons/bs";
import { useTheme, DARK, LIGHT } from '../context/ThemeContext';

export const Contact = () => {


    const { isDark } = useTheme();
    const t = isDark ? DARK : LIGHT;

    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        subject: '',
        message: ''
    });

    const [errors, setErrors] = useState({});
    const [responseMsg, setResponseMsg] = useState(null);
    const [isSuccess, setIsSuccess] = useState(false);
    const messageRef = useRef(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });

        setErrors({
            ...errors,
            [name]: ''
        });
    };

    useEffect(() => {
        if (messageRef.current) {
            messageRef.current.focus();
        }
    }, [responseMsg]);


    const checkValidation = () => {
        const validationErrors = {};
        if (!formData.name.trim()) {
            validationErrors.name = "Name is requried";
        }
        if (!formData.email.trim()) {
            validationErrors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            validationErrors.email = "Invalid email format";
        }
        if (!formData.subject.trim()) {
            validationErrors.subject = "Subject is required";
        }
        if (!formData.message.trim()) {
            validationErrors.message = "Message is required";
        }
        return validationErrors;
    }




    const handleSubmit = async (e) => {
        console.log('submit contact data');
        e.preventDefault();

        const validationErrors = checkValidation();

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        try {
            const response = await axios.post('https://52r03u6z8k.execute-api.us-east-1.amazonaws.com/Staging/send-email',
                formData);

            console.log(response);

            const data = response.data;

            if (response.status >= 200 && response.status < 300) {
                setIsSuccess(true);
                console.log(isSuccess);

                setFormData({
                    name: '',
                    phone: '',
                    email: '',
                    subject: '',
                    message: ''
                });

            } else {
                setIsSuccess(false);
                console.log('hello')
            }

            setResponseMsg(data.message);
        } catch (error) {
            setIsSuccess(false);
            setResponseMsg('Sorry, We could not send your email. Please try again later.');
            console.error('Error:', error);
        }
    }

    const inputStyle = {
    width: '100%',
    padding: '10px 14px',
    background: t.bgAlt,
    border: `1px solid ${t.border}`,
    borderRadius: '8px',
    color: t.text,
    fontSize: '14px',
    outline: 'none',
    transition: 'border-color 0.2s',
  };

    return (
    <section id="contact" style={{ background: t.bg, padding: '60px 0', transition: 'background 0.3s' }}>
      <Container>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '36px' }}>
          <div style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '3px', textTransform: 'uppercase', color: t.accent, marginBottom: '8px' }}>
            Get In Touch
          </div>
          <div style={{ fontSize: '26px', fontWeight: 700, color: t.text }}> 🍀 I'd love to hear from you! 🍀 </div>
        </div>
 
        <Row className="d-flex align-items-start">
          <Col sm={12} md={4} className="text-center order-last order-md-first pt-3">
            <ContactInfo />
          </Col>
          <Col sm={12} md={8}>
            {responseMsg && (
              <div
                className={`alert ${isSuccess ? 'alert-success' : 'alert-danger'} d-flex align-items-center`}
                role="alert" ref={messageRef} tabIndex={-1}
              >
                {isSuccess ? <MdMarkEmailRead className="me-2" /> : <MdError className="me-2" />}
                {responseMsg}
              </div>
            )}
 
            <form onSubmit={handleSubmit}>
              <Row>
                <Col size={12} sm={6} className="mb-3">
                  <input type="text" name="name" value={formData.name} placeholder="Name" onChange={handleChange} style={inputStyle} />
                  <small style={{ color: t.accentOrange }}>{errors.name}</small>
                </Col>
                <Col size={12} sm={6} className="mb-3">
                  <input type="tel" name="phone" value={formData.phone} placeholder="Phone (Optional)" onChange={handleChange} style={inputStyle} />
                </Col>
              </Row>
              <Row>
                <Col className="mb-3">
                  <input type="email" name="email" value={formData.email} placeholder="Email" onChange={handleChange} style={inputStyle} />
                  <small style={{ color: t.accentOrange }}>{errors.email}</small>
                </Col>
              </Row>
              <Row>
                <Col className="mb-3">
                  <input type="text" name="subject" value={formData.subject} placeholder="Subject" onChange={handleChange} style={inputStyle} />
                  <small style={{ color: t.accentOrange }}>{errors.subject}</small>
                </Col>
              </Row>
              <Row>
                <Col className="mb-3">
                  <textarea rows="6" name="message" value={formData.message} placeholder="Message" onChange={handleChange} style={{ ...inputStyle, resize: 'vertical' }} />
                  <small style={{ color: t.accentOrange }}>{errors.message}</small>
                </Col>
              </Row>
              <div className="d-flex justify-content-end">
                <button
                  type="submit"
                  style={{
                    background: t.accent, color: '#fff',
                    border: 'none', borderRadius: '8px',
                    padding: '10px 24px', fontSize: '15px',
                    fontWeight: 600, cursor: 'pointer',
                    display: 'flex', alignItems: 'center', gap: '8px',
                    transition: 'opacity 0.2s',
                  }}
                  onMouseEnter={e => e.currentTarget.style.opacity = '0.85'}
                  onMouseLeave={e => e.currentTarget.style.opacity = '1'}
                >
                  Send Message <BsSendFill />
                </button>
              </div>
            </form>
          </Col>
        </Row>
      </Container>
    </section>
  );
};